import { useQuery } from '@tanstack/react-query';

import { DirectoryService } from './directoryService';
import { DirectoryKey } from './keys';

export function useGetDirectory(id?: string, enabled = true) {
  return useQuery({
    queryKey: [DirectoryKey.DIRECTORY, id],
    queryFn: () => DirectoryService.getDirectory(id).then((response) => response.data),
    enabled: enabled && !!id,
  });
}
